(function () {
  var params = new URLSearchParams(window.location.search);
  var wdwReturn = params.get('wdw_return');
  if (wdwReturn) {
    sessionStorage.setItem('wdw_return', wdwReturn);
  }
})();

class WdwWishlistButton extends HTMLElement {
  connectedCallback() {
    var storedReturn = sessionStorage.getItem('wdw_return');
    if (!storedReturn) {
      this.setAttribute('hidden', '');
      return;
    }

    this.removeAttribute('hidden');

    var btn = this.querySelector('#wdw-add-to-wishlist');
    if (!btn) return;

    btn.addEventListener('click', () => {
      var currentReturn = sessionStorage.getItem('wdw_return');
      if (!currentReturn) return;
      var cleanUrl = window.location.origin + window.location.pathname;
      var redirectUrl = currentReturn + '&product_url=' + encodeURIComponent(cleanUrl);
      sessionStorage.removeItem('wdw_return');
      window.location.href = redirectUrl;
    });
  }
}

customElements.define('wdw-wishlist-button', WdwWishlistButton);
